"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.holidays = void 0;
var utils_1 = require("../../utils");
exports.holidays = function (axios) {
    return {
        getHolidaysYear: function (request) {
            var url = utils_1.paramPathchange('/holidays/{year}', request);
            return axios.get(url);
        }
    };
};
